import clsx from 'clsx';
import { twMerge } from 'tailwind-merge';

// Mosaico ships clsx 1.x (default export only), so the type is declared here
// rather than imported.
export type ClassValue = string | number | boolean | null | undefined | ClassValue[] | Record<string, unknown>;

/**
 * Merge conditional class names and resolve Tailwind conflicts.
 * `clsx` handles conditionals/arrays/objects; `twMerge` ensures the last
 * conflicting Tailwind utility wins (e.g. `cn('p-2', 'p-4')` → `'p-4'`).
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs as never));
}
